export const initialState = {
  history: []
}

export default function(state=initialState, action) {
  const { type } = action
  const payload = action.payload || {}
  const data = payload.data || {}

  switch(type) {
    case 'SHOP_ORDER_AI_HISTORY_LOAD_SUCCEEDED':
      return {
        ...state,
        history: data
      }
    default:
      return state
  }
}
